import React, { ReactNode } from "react";

interface WrapperContentProps {
  children: ReactNode;
}

const WrapperContent: React.FC<WrapperContentProps> = (props) => {
  return <div className="m-4">{props.children}</div>;
};

export default WrapperContent;
